import { render, staticRenderFns } from "./CopiableText.vue?vue&type=template&id=5047a986&scoped=true&"
import script from "./CopiableText.vue?vue&type=script&lang=js&"
export * from "./CopiableText.vue?vue&type=script&lang=js&"
import style0 from "./CopiableText.vue?vue&type=style&index=0&id=5047a986&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5047a986",
  null
  
)

export default component.exports